import Moment from "moment";
import DateSelection from "./date-selection";

export default class DateMonthSelection extends DateSelection {

    constructor() {
        super();
        this.maxMonths = 3;
        this.dateStep = 'month';
    }

    startOfRange(date) {
        let month = this.maxMonths * Math.floor(Moment(date).month() / this.maxMonths);
        let rangeStart = Moment(date).startOf('year').month(month);
        return rangeStart;
    }

    endOfRange(date) {
        let rangeEnd = this.startOfRange(date).add(this.maxMonths -1, 'month');
        return rangeEnd;
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/week-date-selection/date-month-selection.js